import {
  useEffect,
  useLayoutEffect,
  useState,
  useSyncExternalStore,
} from "react";
import { browserCallPorts } from "./browser-call-ports";
import { CallSession, type CallContext } from "./call-session";

export function useCallSession({ notify, userId, systemAlerts }: CallContext) {
  const [session] = useState(
    () => new CallSession(browserCallPorts, { notify, userId, systemAlerts }),
  );
  useLayoutEffect(
    () => session.configure({ notify, userId, systemAlerts }),
    [session, notify, userId, systemAlerts],
  );
  useEffect(() => session.attach(), [session]);
  const snapshot = useSyncExternalStore(session.subscribe, session.getSnapshot);
  return { ...snapshot, session };
}
